export const data = [
	// First row
	{
		thumbnail: {
			title: 'ZWIRN BCT1',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'zwirn.jpg',
		},

		title: 'MULTIFUNCTIONAL APARTMENT SUIT BCT1',
		subTitle: 'APARTMENT HOUSES',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2020',
		investor: 'ZWIRN area s.r.o.',
		architect: 'PROMA, s. r. o.',
		author: 'Compass, s r.o',

		textHeader:
			'Dokumentácia pre realizáciu stavby<br>\n' +
			'Vypracovanie projektu metódou BIM v REVIT Autodesk',
		text:
			'Trafostanica, Prípojka NN, Vonkajšie rozvody NN, Areálové osvetlenie AO, Verejné osvetlenie VO, ' +
			'Vonkajšie slaboprúdové rozvody, Prípojka slaboprúdu - providerov.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, Optická ' +
			'sieť, Domáci audio (video) telefón, Systém kontroly vstupu SKV, Elektrický zabezpečovací systém EZS, ' +
			'Systém priemyselnej televízie CCTV, Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru ' +
			'HSP, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/zwirn.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'PORTUM',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'portum.jpg',
		},

		subTitle: 'MULTIFUNCTIONAL COMPLEX',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2020',
		investor: 'TK ESTATE s.r.o.',
		architect: 'A1 Architecture a.s.',
		author: 'A1 Architecture a.s.',

		textHeader:
			'Dokumentácia pre stavebné povolenie',
		text:
			'VN connection, Substation, NN connection, NN external distribution, Area lighting AO, Public ' +
			'lighting VO, External low current distribution, Low current connection - providers.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Optická sieť, Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie ' +
			'CCTV, Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie a ' +
			'pospojovanie',

		mainImage: 'references/portum.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'GUTHAUS',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'guthaus.jpg',
		},

		title: 'MULTIFUNCTIONAL APARTMENT BUILDING RAČIANSKA',
		subTitle: 'GUTHAUS',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2019 - 2020',
		investor: 'GUTHAUS s.r.o.',
		architect: 'PCK & Partners s.r.o.',
		author: 'AllesWirdGut Architektur ZT GmbH',

		textHeader:
			'Dokumentácia pre realizáciu stavby<br>\n' +
			'Zmena stavby pred jej dokončením',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody NN, Areálové osvetlenie AO.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Optická sieť, Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie ' +
			'CCTV, Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie a ' +
			'pospojovanie',

		mainImage: 'references/guthaus.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'EPERIA',
			subTitle: 'SHOPPING CENTER',
			image: 'eperia.jpg',
		},

		title: 'EPERIA 1st and 2nd STAGE',
		subTitle: 'SHOPPING CENTER',

		country: 'Slovak Republic',
		location: 'Prešov',
		completion: '2015 - 2019',
		investor: 'VSV Consulting, a.s.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: null,

		textHeader:
			'Dokumentácia pre územné rozhodnutie<br>\n' +
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia skutočného vyhotovenia<br>\n' +
			'Zmena stavby pred jej dokončením',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody VN, Vonkajšie rozvody NN, Areálové ' +
			'osvetlenie AO, Verejné osvetlenie VO, Vonkajšie slaboprúdové rozvody, Prípojka slaboprúdu - ' +
			'providerov.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, Optická ' +
			'sieť, Domáci audio (video) telefón, Systém kontroly vstupu SKV, Elektrický zabezpečovací systém EZS, ' +
			'Systém priemyselnej televízie CCTV, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'index/eperia.jpg',
		images: [],
	},

	// Second row
	{
		thumbnail: {
			title: 'BOTTOVA',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'bottova.jpg',
		},

		title: 'BOTTOVA RESIDENCE',
		subTitle: 'MULTIFUNCTIONAL COMPLEX',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2018 – 2020',
		investor: 'Development 5, s.r.o.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: 'City Work Architects s.r.o.',

		textHeader:
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia pre realizáciu stavby',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody NN, Areálové osvetlenie AO, Verejné ' +
			'osvetlenie VO, Prípojka slaboprúdu - providerov.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Optická sieť, Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie ' +
			'CCTV, Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie ' +
			'a pospojovanie',

		mainImage: 'references/bottova.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'OMNIA',
			subTitle: 'BUSINESS CENTER',
			image: 'omnia.jpg',
		},

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2019',
		investor: 'OMNIA INVEST s.r.o.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: 'FVA, s.r.o.',

		textHeader:
			'Dokumentácia pre realizáciu stavby',
		text:
			'Prípojka VN, Vonkajšie rozvody NN, Areálové osvetlenie AO, Verejné osvetlenie VO, Vonkajšie slaboprúdové ' +
			'rozvody, Prípojka slaboprúdu - providerov.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, Optická ' +
			'sieť, Domáci audio (video) telefón, Systém kontroly vstupu SKV, Elektrický zabezpečovací systém EZS, ' +
			'Systém priemyselnej televízie CCTV, Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru ' +
			'HSP, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/omnia.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'NIDO',
			subTitle: 'HOUSING ESTATE',
			image: 'nido.jpg',
		},

		title: 'FLAT HOUSE TOMÁŠIKOVÁ - TRNAVSKÁ',
		subTitle: 'NIDO',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2016',
		investor: 'Murlabo Slovakia, s.r.o.',
		architect: 'Grido architekti, s.r.o.',
		author: 'Grido architekti, s.r.o.',

		textHeader:
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia pre realizáciu stavby<br>\n' +
			'Cena za architektúru 2019',
		text:
			'Prípojka NN, Vonkajšie rozvody NN, Areálové osvetlenie AO.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie CCTV, ' +
			'Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/nido.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'PREMIÉRE',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'premiere.jpg',
		},

		subTitle: 'MULTIFUNCTIONAL OBJECT',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2014 - 2018',
		investor: 'FINEP Premiére, s.r.o.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: 'AHK architekti s.r.o.',

		textHeader:
			'Dokumentácia pre územné rozhodnutie<br>\n' +
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia pre realizáciu stavby<br>\n' +
			'Zmena stavby pred jej dokončením',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody NN, Areálové osvetlenie AO, Verejné ' +
			'osvetlenie VO.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie CCTV, ' +
			'Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie a ' +
			'pospojovanie',

		mainImage: 'references/premiere.jpg',
		images: [],
	},

	// Third row
	{
		thumbnail: {
			title: 'SAIDA',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'saida.jpg',
		},

		subTitle: 'MULTIFUNCTIONAL FLAT HOUSE',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2020',
		investor: 'SAIDA s.r.o.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: null,

		textHeader:
			'Dokumentácia pre stavebné povolenie',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Areálové osvetlenie AO, Prípojka slaboprúdu.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie CCTV, ' +
			'Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie a ' +
			'pospojovanie',

		mainImage: 'references/saida.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'JÉGEHO ALEJ V',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'cvernovka.jpg',
		},

		title: 'MULTIFUNCTIONAL COMPLEX NOVÁ CVERNOVKA',
		subTitle: 'CENTURY RESIDENCE, objects A, B, C, D, E, P',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2016 - 2019',
		investor: 'FINEP Jégeho alej, a.s.',
		architect: 'BUILDING s. r. o.',
		author: 'A69 – architekti s.r.o.',

		textHeader:
			'Dokumentácia pre územné rozhodnutie<br>\n' +
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia pre realizáciu stavby<br>\n' +
			'Zmena stavby pred jej dokončením',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody VN, Vonkajšie rozvody NN, Areálové osvetlenie ' +
			'AO.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie CCTV, ' +
			'Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie a ' +
			'pospojovanie',

		mainImage: 'references/cvernovka.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'PEKNÁ VYHLIADKA',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'laskonka.jpg',
		},

		title: 'MULTIFUNCTIONAL OBJECT L1, L2',
		subTitle: 'Pekná vyhliadka',

		country: 'Slovak Republic',
		location: 'Bratislava',
		completion: '2015 - 2018',
		investor: 'ARCH-INVEST, s.r.o.',
		architect: [
			'OBERMEYER HELIKA s.r.o.',
			'VAVRICA ARCHITEKTI s.r.o.',
		],
		author: 'VAVRICA ARCHITEKTI s.r.o.',

		textHeader:
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia pre realizáciu stavby',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody NN, Areálové osvetlenie AO, Prípojka ' +
			'slaboprúdu.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Domáci audio (video) telefón, Systém kontroly vstupu SKV, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/laskonka.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'ARBORIA',
			subTitle: 'MULTIFUNCTIONAL COMPLEX',
			image: 'arboria.jpg',
		},

		title: 'RESIDENTIAL SUIT, TRNAVA ZÁTVOR II.',
		subTitle: 'FLAT HOUSES B05, B06 ARBORIA',

		country: 'Slovak Republic',
		location: 'Trnava',
		completion: '2017 - 2018',
		investor: 'LUCRON DEVELOPMENT',
		architect: [
			'OBERMEYER HELIKA s.r.o.',
			'O+Ondriaš A3A – architekti, s.r.o.',
		],
		author: 'O+Ondriaš A3A – architekti, s.r.o.',

		textHeader:
			'Dokumentácia pre realizáciu stavby<br>\n' +
			'Zmena stavby pred jej dokončením',
		text:
			'<b>Zmena stavby pred jej dokončením</b><br>\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Domáci audio (video) telefón, Systém kontroly vstupu SKV, Systém priemyselnej televízie CCTV, ' +
			'Elektrická požiarna signalizácia EPS, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/arboria.jpg',
		images: [],
	},

	// Fourth row
	{
		thumbnail: {
			title: 'CAMPUS TT',
			subTitle: 'SCHOOL AREA',
			image: 'mtf_trnava.jpg',
		},

		title: 'CAMPUS – MTF TRNAVA',
		subTitle: 'SCHOOL AREA',

		country: 'Slovak Republic',
		location: 'Bottov ául. Trnava',
		completion: '2014',
		investor: 'Materiálovo technologická fakulta STU Trnava',
		architect: 'Atrios Architects s. r. o.',
		author: 'Ing. arch. Roman Klenovič',

		textHeader:
			'Dokumentácia pre realizáciu stavby',
		text:
			'Prípojka NN, Vonkajšie rozvody VN, Vonkajšie rozvody NN, Areálové osvetlenie AO, Verejné osvetlenie VO\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Elektrický zabezpečovací systém EZS, Systém priemyselnej televízie CCTV, Hlasová signalizácia požiaru ' +
			'HSP, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/mtf_trnava.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'DAMIAN',
			subTitle: 'HOTEL',
			image: 'damian.jpg',
		},

		title: 'HOTEL DAMIAN',
		subTitle: 'DEMÄNOVSKÁ DOLINA',

		country: 'Slovak Republic',
		location: 'Jasná Demänovská dolina',
		completion: '2018',
		investor: 'DAMIAN JASNA, s. r. o.',
		architect: 'NEXTWORK ARCHITECTURE, s. r. o.',
		author: 'NEXTWORK ARCHITECTURE, s. r. o.',

		textHeader:
			'Dokumentácia pre realizáciu stavby',
		text:
			'Prípojka VN, Trafostanica, Vonkajšie rozvody VN, Vonkajšie rozvody NN, Areálové osvetlenie AO.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/damian.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'GUHRING',
			subTitle: 'PRODUCTION AND ADMINISTRATIVE FACILITY',
			image: 'guhring.jpg',
		},

		title: 'PRODUCTION AND ADMINISTRATIVE FACILITY',
		subTitle: 'GUHRING, Beluša',

		country: 'Slovak Republic',
		location: 'Beluša',
		completion: '2017 - 2018',
		investor: 'GÜHRING Slovakia, s.r.o.',
		architect: 'PROMA, s. r. o.',
		author: 'Ing. arch. Daniela Majerčíková',

		textHeader:
			'Dokumentácia pre stavebné povolenie<br>\n' +
			'Dokumentácia pre realizáciu stavby',
		text:
			'Prípojka VN, Trafostanica, Areálové osvetlenie AO.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Elektrická požiarna signalizácia EPS, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/guhring.jpg',
		images: [],
	},
	{
		thumbnail: {
			title: 'VGP PARK MALACKY',
			subTitle: 'PRODUCTION HALL',
			image: 'vgp_malacky.jpg',
		},

		title: 'Production hall A, B, C, D, E',
		subTitle: 'PTPZ EUROVALLEY MALACKY – VGP PARK MALACKY',

		country: 'Slovak Republic',
		location: 'Malacky',
		completion: '2015 - 2019',
		investor: 'VGP Slovakia a.s.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: null,

		textHeader:
			'Dokumentácia pre stavebné povolenie – hala D, E<br>\n' +
			'Dokumentácia pre realizáciu stavby – hala B, E<br>\n' +
			'Zmena stavby pred jej dokončením – hala E<br>\n' +
			'Dokumentácie nájomných jednotiek – hala A, B, C',
		text:
			'Prípojka VN, Trafostanica, Prípojka NN, Vonkajšie rozvody VN, Vonkajšie rozvody NN, Areálové osvetlenie ' +
			'AO, Vonkajšie slaboprúdové rozvody, Prípojka slaboprúdu - providerov.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Systém kontroly vstupu SKV, Elektrický zabezpečovací systém EZS, Systém priemyselnej televízie CCTV, ' +
			'Elektrická požiarna signalizácia EPS, Hlasová signalizácia požiaru HSP, Bleskozvod, uzemnenie a ' +
			'pospojovanie, Meranie a regulácia MaR, Rozvody elektrotechnológie',

		mainImage: 'references/vgp_malacky.jpg',
		images: [],
	},

	// Fifth row
	{
		thumbnail: {
			title: 'CTPark Trnava',
			subTitle: 'PRODUCTION HALL',
			image: 'ctpark.jpg',
		},

		title: '13 logistics halls - TRN01–TRN05, TRN07-TRN11, TRN16–TRN18, SHZ nádrž',
		subTitle: 'CTPark Trnava Zavar',

		country: 'Slovak Republic',
		location: 'Trnava',
		completion: '2016',
		investor: 'CTP Invest SK, spol. s r.o.',
		architect: 'OBERMEYER HELIKA s.r.o.',
		author: 'CTP Invest SK, spol. s r.o.',

		textHeader:
			'Dokumentácia pre stavebné povolenie',
		text:
			'Prípojka NN, Areálové osvetlenie AO, Vonkajšie slaboprúdové rozvody, Prípojka slaboprúdu - providerov.\n' +
			'Vnútorné silnoprúdové rozvody, Umelé osvetlenie, Núdzové osvetlenie, Štruktúrovaná kabeláž DAT, ' +
			'Elektrická požiarna signalizácia EPS, Bleskozvod, uzemnenie a pospojovanie',

		mainImage: 'references/ctpark.jpg',
		images: [],
	},
];
